import './bookforyou.css'

const BookForYou = () => {
  return (
    <section className='bookForYou section__padding'>

      {/* BLOQUE 1 */}
      <div className='bookForYou__block'>
        <h2 className='bookForYou__title'>
          Este libro es para ti si…
        </h2>

        <div className='bookForYou__text'>
          <p>
            Acompañas procesos educativos (escuelas, institutos, universidades,
            educación no formal).
          </p>
          <p>
            Trabajas en salud, igualdad, participación comunitaria o políticas públicas.
          </p>
          <p>
            Facilitas talleres de ciclo menstrual, menopausia o derechos menstruales.
          </p>
          <p>
            Buscas un marco sólido para tu práctica como educadora menstrual.
          </p>
        </div>
      </div>

      {/* BLOQUE 2 */}
      <div className='bookForYou__block'>
        <h2 className='bookForYou__title'>
          Con este libro podrás…
        </h2>

        <div className='bookForYou__text'>
          <p>
            Comprender los fundamentos conceptuales de la educación menstrual
            y su marco ético.
          </p>
          <p>
            Diseñar talleres y procesos educativos con perspectiva feminista,
            interseccional y eco-social.
          </p>
          <p>
            Nombrar y defender los derechos menstruales en tu territorio.
          </p>
          <p>
            Conectarte con una red internacional de referentes y experiencias.
          </p>
        </div>
      </div>

    </section>
  )
}

export default BookForYou
